import { ComponentType } from 'react';

import { useSelector } from '../../modules/useSelector';
import useTranslations, { T, TranslatedComponent } from './useTranslations';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const translation = <P extends Record<string, any>>(WrappedComponent: TranslatedComponent<P>): ComponentType<P> => {
    const TranslationWrapper = (props: P) => {
        const { trl, defaultLang } = useSelector(({ trl, langs }) => ({
            trl,
            defaultLang: langs[0],
        }));
        const trls = useTranslations(WrappedComponent, trl, defaultLang, !!process.env.SSR);
        return <T {...props} trls={trls} Element={WrappedComponent} />;
    };

    return TranslationWrapper;
};

export default translation;
